import axios from "axios";
import React from "react";
import { useRouteMatch } from "react-router-dom";
import CouponForm from "../components/Coupon/CouponForm";
import GoBackButton from "../components/Misc/GoBackButton";
import Loading from "../components/Misc/Loading";
import { api } from "../config";
import { Coupon } from "../types/apiTypes";

const CouponFormPage: React.FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [coupon, setCoupon] = React.useState<Coupon>();
  const match = useRouteMatch("/admin/coupon-form/:id");
  const isEdit = match !== null;
  let id = "";

  if (isEdit) {
    //@ts-ignore
    id = match?.params.id;
  }
  const fetchCoupon = React.useCallback(async () => {
    const { data } = await axios.get(`${api}/coupons/${id}`, {
      withCredentials: true,
    });
    setCoupon(data);
    setLoading(false);
  }, [id]);

  React.useEffect(() => {
    if (id) {
      fetchCoupon();
    } else {
      setLoading(false);
    }
  }, [fetchCoupon, id]);

  if (loading) return <Loading />;

  if (id) {
    return (
      <div>
        <GoBackButton />
        <CouponForm coupon={coupon} />
      </div>
    );
  }
  return (
    <div>
      <GoBackButton />
      <CouponForm />
    </div>
  );
};

export default CouponFormPage;
